import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Droplet, Box, Crown, ArrowRight, Instagram, Star, Send, Music2, ChevronLeft, ChevronRight } from 'lucide-react';
import { INSTAGRAM_URL, TIKTOK_URL } from '../data/mock';
import { FEATURES, REVIEWS, GALLERY, TELEGRAM_URL, PRODUCTS } from '../data/mock';
import { fetchProducts, fetchReviews, subscribeNewsletter, submitReview } from '../lib/api';
import PromoSlider from '../components/PromoSlider';
import CaliLetters from '../components/CaliLetters';

const iconMap = { Leaf, Droplet, Box, Crown };

const Home = () => {
  const [featured, setFeatured] = useState([]);
  const [reviews, setReviews] = useState(REVIEWS);
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [reviewOpen, setReviewOpen] = useState(false);
  const [reviewForm, setReviewForm] = useState({ name: '', rating: 5, text: '', product: '' });
  const [ediblessIndex, setEdiblessIndex] = useState(0);
  const productSlides = (featured.length ? featured : PRODUCTS).slice(0, 6);
  const activeEdiblessProduct = productSlides[ediblessIndex % Math.max(productSlides.length, 1)];

  useEffect(() => {
    fetchProducts().then((d) => setFeatured(d.slice(0, 6))).catch(() => {});
    fetchReviews().then((d) => {
      if (d && d.length) {
        const sorted = [...d].sort((a, b) => Number(Boolean(b.featured)) - Number(Boolean(a.featured)));
        setReviews(sorted.slice(0, 8));
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (productSlides.length <= 1) return undefined;
    const t = setInterval(() => {
      setEdiblessIndex((prev) => (prev + 1) % productSlides.length);
    }, 4200);
    return () => clearInterval(t);
  }, [productSlides.length]);

  useEffect(() => {
    if (productSlides.length && ediblessIndex >= productSlides.length) {
      setEdiblessIndex(0);
    }
  }, [ediblessIndex, productSlides.length]);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      await subscribeNewsletter(email);
      setSubscribed(true);
      setEmail('');
    } catch { setSubscribed(true); }
  };

  const handleAddReview = async (e) => {
    e.preventDefault();
    try {
      const created = await submitReview(reviewForm);
      setReviews((prev) => [created, ...prev].slice(0, 8));
    } catch { /* ignore */ }
    setReviewOpen(false);
    setReviewForm({ name: '', rating: 5, text: '', product: '' });
  };

  return (
    <div className="pt-[74px]">
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 smoke-red opacity-70" />
        <div className="absolute inset-0 cb-noise opacity-40" />
        <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-8 lg:py-16 grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-10 items-center">
          {/* Left */}
          <div className="cb-fade-up order-2 lg:order-1 flex flex-col items-center lg:items-start text-center lg:text-left">
            <p className="text-white/75 text-sm sm:text-base lg:text-lg max-w-md mb-6 sm:mb-8">
              Produkty stworzone z pasji do wyjątkowych doznań. Najwyższa jakość THC,
              niepowtarzalny smak i styl życia <span className="text-[#a6e22e] font-semibold">Cali Boyz.</span>
            </p>
            <div className="flex flex-wrap justify-center lg:justify-start gap-3 sm:gap-4">
              <Link to="/produkty" className="btn-green px-5 sm:px-7 py-3 sm:py-3.5 inline-flex items-center gap-2 text-sm sm:text-base">
                ZOBACZ PRODUKTY <Leaf size={18} />
              </Link>
              <Link to="/o-nas" className="btn-ghost-red px-5 sm:px-7 py-3 sm:py-3.5 inline-flex items-center gap-2 text-sm sm:text-base">
                O NAS <Crown size={18} />
              </Link>
            </div>
          </div>

          {/* Right visual */}
          <div className="relative cb-fade-up order-1 lg:order-2 w-full max-w-[520px] sm:max-w-[620px] lg:max-w-none mx-auto">
            <div className="relative">
              <img src="/products/hero-guy.png" alt="Cali Boyz" className="relative w-full max-w-[560px] lg:max-w-[520px] mx-auto h-auto object-contain contrast-110 saturate-110" />
            </div>
            <div className="absolute top-2 left-2 lg:-top-2 lg:-left-2 h-12 w-12 sm:h-14 sm:w-14 rounded-full border border-[#a6e22e]/50 grid place-items-center text-[#a6e22e] font-bangers text-base sm:text-lg bg-black/80">18+</div>

            {/* Vertical socials */}
            <div className="hidden md:flex flex-col gap-3 absolute right-0 lg:-right-2 top-1/2 -translate-y-1/2">
              {[{ i: Instagram, href: INSTAGRAM_URL }, { i: Music2, href: TIKTOK_URL }, { i: Leaf, href: '#' }].map((s, k) => (
                <a key={k} href={s.href} target="_blank" rel="noreferrer" className="h-11 w-11 rounded-full border border-[#a6e22e]/40 bg-black/70 grid place-items-center text-[#a6e22e] hover:bg-[#a6e22e] hover:text-black transition">
                  <s.i size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Marquee strip */}
        <div className="relative border-y border-white/10 bg-black/60 py-3 overflow-hidden">
          <div className="marquee-track">
            {Array.from({ length: 2 }).map((_, r) => (
                <div key={r} className="marquee-set flex items-center gap-16 pr-16">
                {['EDIBLESS NR 1', 'QUALITY 420%', 'PREMIUM THC', 'HIGH ON DREAM', 'CALI BOYZ', 'MOCNE DOZNANIA'].map((t, i) => (
                    <span key={i} className="marquee-phrase font-bangers text-xl text-white/80 flex items-center gap-6">
                      <CaliLetters text={t} /> <Leaf size={16} className="text-[#a6e22e]" />
                    </span>
                  ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROMO SLIDER */}
      <PromoSlider />

      {/* NASZE PRODUKTY */}
      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-16">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div className="flex flex-col items-center">
            <Crown className="text-[#ffb000] mb-3 drop-shadow-[0_0_18px_rgba(255,176,0,0.45)]" size={64} strokeWidth={1.8} />
            <h2 className="font-anton text-4xl lg:text-5xl uppercase">
              <CaliLetters text="NASZE PRODUKTY" />
            </h2>
          </div>
          <Link to="/produkty" className="btn-green px-6 py-3 inline-flex items-center gap-2 self-start">
            ZOBACZ WSZYSTKIE <Leaf size={16} />
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {featured.map((p) => (
            <Link key={p.id} to={`/produkt/${p.id}`} className="product-card group cb-panel rounded-2xl border border-white/10 overflow-hidden">
              <div className="aspect-square bg-gradient-to-b from-white/5 to-transparent overflow-hidden">
                <img src={p.image} alt={p.name} className={`h-full w-full object-contain p-4 transition-transform duration-500 group-hover:scale-110 ${!p.inStock ? 'opacity-40 grayscale' : ''}`} />
              </div>
              <div className="p-3 text-center">
                <p className="font-anton uppercase text-lg leading-tight group-hover:text-[#a6e22e] transition-colors">
                  <CaliLetters text={p.name.replace(/\d.*/, '').trim().toUpperCase()} />
                </p>
                <p className="text-[#a6e22e] text-sm font-bold mt-1">od {p.price.toFixed(2)} zł</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* EDIBLESS BANNER + FEATURES */}
      <section className="relative">
        <div className="absolute inset-0 smoke-red opacity-50" />
        <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-16">
          <div className="cb-panel rounded-3xl border border-white/10 p-5 sm:p-8 lg:p-12 grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-10 items-center overflow-hidden">
            <div className="flex flex-col items-start">
              <img src="/products/edibless.png" alt="Edibless nr 1! Quality 420%!" className="w-full max-w-[420px] h-auto glow-pulse" />
              <Link to="/produkty" className="btn-green px-5 sm:px-7 py-3 sm:py-3.5 inline-flex items-center gap-2 mt-5 sm:mt-6 text-sm sm:text-base">
                SPRAWDŹ OFERTĘ <ArrowRight size={18} />
              </Link>
            </div>
            <div className="relative min-h-[300px] sm:min-h-[360px] overflow-hidden rounded-2xl border border-white/10 bg-black/45">
              {activeEdiblessProduct && (
                <Link to={`/produkt/${activeEdiblessProduct.id}`} className="group absolute inset-0 block">
                  <img src={activeEdiblessProduct.image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full scale-125 object-cover blur-2xl opacity-35" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/35 to-transparent" />
                  <div className="relative z-10 flex h-full flex-col items-center justify-center px-5 pb-20 pt-6 text-center">
                    <img src={activeEdiblessProduct.image} alt={activeEdiblessProduct.name} className="h-[190px] sm:h-[240px] w-full object-contain transition-transform duration-500 group-hover:scale-105" />
                    <h3 className="mt-4 font-bangers text-2xl sm:text-4xl leading-tight">
                      <CaliLetters text={activeEdiblessProduct.name.replace(/\d.*/, '').trim().toUpperCase()} />
                    </h3>
                    <p className="mt-2 text-[#a6e22e] text-lg sm:text-xl font-black">od {activeEdiblessProduct.price.toFixed(2)} zł</p>
                  </div>
                </Link>
              )}

              {productSlides.length > 1 && (
                <>
                  <button type="button" onClick={() => setEdiblessIndex((prev) => (prev - 1 + productSlides.length) % productSlides.length)} className="absolute left-3 top-1/2 z-20 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full border border-white/15 bg-black/65 text-white transition hover:bg-[#a6e22e] hover:text-black">
                    <ChevronLeft size={20} />
                  </button>
                  <button type="button" onClick={() => setEdiblessIndex((prev) => (prev + 1) % productSlides.length)} className="absolute right-3 top-1/2 z-20 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full border border-white/15 bg-black/65 text-white transition hover:bg-[#a6e22e] hover:text-black">
                    <ChevronRight size={20} />
                  </button>
                  <div className="absolute bottom-4 left-1/2 z-20 flex -translate-x-1/2 gap-2">
                    {productSlides.map((p, idx) => (
                      <button key={p.id} type="button" onClick={() => setEdiblessIndex(idx)} className={`h-2 rounded-full transition-all ${idx === ediblessIndex % productSlides.length ? 'w-7 bg-[#a6e22e]' : 'w-2 bg-white/40'}`} />
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Features */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
            {FEATURES.map((f) => {
              const Icon = iconMap[f.icon];
              return (
                <div key={f.title} className="text-center px-4">
                  <div className="mx-auto mb-4 h-16 w-16 rounded-full border-2 border-[#a6e22e]/50 grid place-items-center text-[#a6e22e]">
                    <Icon size={26} />
                  </div>
                  <h3 className="font-anton uppercase text-sm text-[#a6e22e] mb-2">{f.title}</h3>
                  <p className="text-white/60 text-sm">{f.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* REVIEWS */}
      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-12">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-10">
          <h2 className="font-anton text-3xl lg:text-4xl uppercase text-center sm:text-left">
            <CaliLetters text="CO MÓWIĄ KLIENCI" />
          </h2>
          <button onClick={() => setReviewOpen(true)} className="btn-ghost-red px-5 py-2.5 inline-flex items-center gap-2"><Star size={16} /> Dodaj opinię</button>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {reviews.map((r, i) => (
            <div key={r.id || i} className={`cb-panel rounded-2xl border p-5 ${r.featured ? 'md:col-span-2 lg:col-span-4 border-[#a6e22e]/50 smoke-red' : 'border-white/10'}`}>
              <div className="flex flex-wrap items-center gap-3 text-[#ffb000] mb-3">
                {Array.from({ length: 5 }).map((_, s) => <Star key={s} size={14} className={s < r.rating ? 'fill-[#ffb000]' : 'opacity-30'} />)}
                {r.featured && (
                  <span className="rounded-full border border-[#a6e22e]/40 bg-[#a6e22e]/10 px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-[#a6e22e]">
                    Wyróżniona opinia
                  </span>
                )}
              </div>
              <p className={`text-white/80 mb-4 ${r.featured ? 'text-sm sm:text-base leading-relaxed' : 'text-sm'}`}>&ldquo;{r.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <span className="font-semibold text-sm">{r.name}</span>
                <span className="text-white/40 text-xs">{r.product}</span>
              </div>
            </div>
          ))}
        </div>

        {reviewOpen && (
          <div className="fixed inset-0 z-[95] bg-black/80 grid place-items-center p-4" onClick={() => setReviewOpen(false)}>
            <form onClick={(e) => e.stopPropagation()} onSubmit={handleAddReview} className="w-full max-w-md cb-panel border border-white/10 rounded-2xl p-6">
              <h3 className="font-anton uppercase text-xl mb-4">Twoja <span className="graffiti-gradient">opinia</span></h3>
              <input required value={reviewForm.name} onChange={(e) => setReviewForm({ ...reviewForm, name: e.target.value })} placeholder="Imię / nick" className="w-full mb-3 rounded-xl bg-black/60 border border-white/15 px-4 py-3 text-sm outline-none focus:border-[#a6e22e]" />
              <div className="flex items-center gap-2 mb-3">
                <span className="text-white/60 text-sm">Ocena:</span>
                {[1, 2, 3, 4, 5].map((s) => (
                  <button type="button" key={s} onClick={() => setReviewForm({ ...reviewForm, rating: s })}>
                    <Star size={22} className={s <= reviewForm.rating ? 'fill-[#ffb000] text-[#ffb000]' : 'text-white/30'} />
                  </button>
                ))}
              </div>
              <input value={reviewForm.product} onChange={(e) => setReviewForm({ ...reviewForm, product: e.target.value })} placeholder="Produkt (opcjonalnie)" className="w-full mb-3 rounded-xl bg-black/60 border border-white/15 px-4 py-3 text-sm outline-none focus:border-[#a6e22e]" />
              <textarea required rows={4} value={reviewForm.text} onChange={(e) => setReviewForm({ ...reviewForm, text: e.target.value })} placeholder="Twoja opinia..." className="w-full mb-4 rounded-xl bg-black/60 border border-white/15 px-4 py-3 text-sm outline-none focus:border-[#a6e22e] resize-none" />
              <button className="btn-green w-full py-3">Wyślij opinię</button>
            </form>
          </div>
        )}
      </section>

      {/* INSTAGRAM */}
      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-12">
        <div className="flex items-center justify-center gap-3 mb-8">
          <Instagram className="text-[#a6e22e]" />
          <h2 className="font-anton text-2xl lg:text-3xl uppercase">
            <CaliLetters text="OBSERWUJ NAS NA INSTAGRAMIE" />
          </h2>
          <ArrowRight className="text-[#a6e22e]" />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {GALLERY.slice(0, 6).map((img, i) => (
            <a key={i} href="https://instagram.com" target="_blank" rel="noreferrer" className="group relative aspect-square rounded-xl overflow-hidden border border-white/10 bg-black/40">
              <img src={img} alt="" className="h-full w-full object-contain p-3 transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition grid place-items-center">
                <Instagram className="text-[#a6e22e]" />
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* NEWSLETTER */}
      <section className="relative">
        <div className="absolute inset-0 smoke-red opacity-40" />
        <div className="relative max-w-4xl mx-auto px-4 lg:px-8 py-16 text-center">
          <h2 className="font-bangers text-4xl lg:text-5xl mb-3">
            <CaliLetters text="ZAPISZ SIĘ DO NEWSLETTERA" />
          </h2>
          <p className="text-white/70 mb-6">Powiadomienia o nowych produktach i kody rabatowe prosto na Twój e-mail!</p>
          {subscribed ? (
            <p className="text-[#a6e22e] font-semibold py-3">Dziękujemy! Zapisano do newslettera.</p>
          ) : (
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Twój adres e-mail" className="flex-1 rounded-full bg-black/60 border border-white/15 px-5 py-3 text-sm outline-none focus:border-[#a6e22e] transition" />
              <button className="btn-green px-6 py-3">ZAPISZ SIĘ</button>
            </form>
          )}
          <a href={TELEGRAM_URL} target="_blank" rel="noreferrer" className="btn-ghost-red inline-flex items-center gap-2 mt-6 px-6 py-3">
            <Send size={17} /> Dołącz do nas na Telegramie
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;
